import { render, staticRenderFns } from "./editApplication.vue?vue&type=template&id=1ad55ffd&scoped=true"
import script from "./editApplication.vue?vue&type=script&lang=js"
export * from "./editApplication.vue?vue&type=script&lang=js"
import style0 from "./editApplication.vue?vue&type=style&index=0&id=1ad55ffd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad55ffd",
  null
  
)

export default component.exports